<app-mat-spinner-overlay *ngIf="loading" overlay="true"></app-mat-spinner-overlay>
<div class="p-3">
  <div class="modal-header py-2 inset-box-shadow">
    <h4 class="m-0 align-self-end">New Character</h4>
    <button type="button" class="close" aria-label="Close"
            (click)="activeModal.dismiss('cancel')" id="closeModalBtn">
      <span>&times;</span>
    </button>
  </div>

  <div class="modal-body w-100" style="height: 610px">
    <mat-tab-group mat-align-tabs="center" [disableRipple]="true" [(selectedIndex)]="tabIndex"
                   (selectedTabChange)="onTabChange($event)" class="w-100">

      <form [formGroup]="characterForm">
        <mat-tab #CharacterInfo label="Character Info" [disabled]='!CharacterInfo.isActive'>
          <div class="mt-3 mb-3 mr-2 col-5">
            <label>Character Name</label>
            <input formControlName="characterName" type="text" class="form-control" ngbAutofocus>
          </div>
          <div class="d-flex w-50">
            <div class="mb-3 col-6">
              <label>Background</label>
              <input formControlName="background" type="text" class="form-control">
            </div>
            <div class="mb-3 col-6">
              <label>Alignment</label>
              <input formControlName="alignment" type="text" class="form-control">
            </div>
            <div class="mb-3 col-6">
              <label>Personality Traits</label>
              <input formControlName="personalityTraits" type="text" class="form-control">
            </div>
          </div>

          <div class="d-flex w-50">
            <div class="mb-3 col-6">
              <label>Ideals</label>
              <input formControlName="ideals" type="text" class="form-control">
            </div>
            <div class="mb-3 col-6">
              <label>Bonds</label>
              <input formControlName="bonds" type="text" class="form-control">
            </div>
            <div class="mb-3 col-6">
              <label>Flaws</label>
              <input formControlName="flaws" type="text" class="form-control">
            </div>
          </div>

          <div class="form-group ml-3 mr-3">
            <label>Backstory</label>
            <textarea id="backstory" rows="3" type="text-area" class="form-control" formControlName="backstory">
            </textarea>
          </div>
        </mat-tab>

        <mat-tab #Race label="Race" [disabled]='!Race.isActive'>
          <div class="d-flex mt-3 border" style="height: 96%">
            <div class="d-flex flex-column col-3 mt-2">
              <div class="d-flex flex-column justify-content-center">
                <label>Race</label>
                <div class="btn-group">
                  <input formControlName="race" type="text" class="form-control dropdown-input">
                  <div class="btn-group" ngbDropdown placement="bottom-right" role="group" aria-label="Race">
                    <button class="btn btn-outline-secondary" ngbDropdownToggle></button>
                    <div class="dropdown-menu custom-scrollbar" ngbDropdownMenu>
                      <button *ngFor="let race of races" ngbDropdownItem (click)="selectRace(race)">
                        {{race}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="languageOptions" class="d-flex flex-column justify-content-center mt-3" [@fadeIn]="languageOptions">
                <label>Languages (Choose {{languageOptions['choose']}})</label>
                <div class="btn-group">
                  <input #languageInput type="text" class="form-control dropdown-input"
                         [disabled]="this.characterForm.get('languages').value.length === languageOptions['choose']">
                  <div class="btn-group" ngbDropdown placement="bottom-right" role="group" aria-label="Languages">
                    <button class="btn btn-outline-secondary" ngbDropdownToggle
                            [disabled]="this.characterForm.get('languages').value.length === languageOptions['choose']"></button>
                    <div class="dropdown-menu custom-scrollbar mb-5" ngbDropdownMenu>
                      <button *ngFor="let language of languageOptions['from']" ngbDropdownItem (click)="selectLanguage(language.name);
                      languageInput.value = language.name">
                        {{language.name}}
                      </button>
                    </div>
                  </div>
                </div>
                <mat-chip-list aria-label="Lang selection">
                  <span *ngIf="this.characterForm.get('languages').value"
                        class="d-flex justify-content-start flex-wrap w-100 mt-2">
                  <mat-chip *ngFor="let lang of this.characterForm.get('languages').value"
                            class="d-flex justify-content-between">
                    {{lang}}
                    <fa-icon [icon]="faTimesCircle" (click)="removeLangChip(lang)"
                             class="text-muted clickable faTimesCircle ml-2">
                    </fa-icon>
                  </mat-chip>
                   </span>
                </mat-chip-list>
              </div>
            </div>
            <div class="bg-light h-100 w-100 pt-2 pr-3 pl-3 border-left pb-2 custom-scrollbar"
                 style="font-size: 0.8em; height: 96%;" id="raceDescription">
              <p *ngIf="raceDescription" [innerHtml]="raceDescription | bypassHtml" [@fadeIn]="raceDescription"></p>
            </div>
          </div>
        </mat-tab>

        <mat-tab #Class label="Class" [disabled]='!Class.isActive'>
          <div class="d-flex mt-3 border" style="height: 96%">
            <div class="d-flex flex-column col-3 pb-4 h-100 custom-scrollbar">
              <div class="d-flex flex-column justify-content-center mt-2">
                <label>Class</label>
                <div class="btn-group">
                  <input formControlName="class" type="text" class="form-control dropdown-input">
                  <div class="btn-group" ngbDropdown placement="bottom-right" role="group" aria-label="Class">
                    <button class="btn btn-outline-secondary" ngbDropdownToggle></button>
                    <div class="dropdown-menu custom-scrollbar mb-5" ngbDropdownMenu>
                      <button *ngFor="let _class of classes" ngbDropdownItem (click)="selectClass(_class)">
                        {{_class}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="profMaps && profMaps.length > 0">
                <div *ngFor="let profMap of profMaps; let i = index;" class="d-flex flex-column mt-3"
                     [@fadeIn]="profMaps && profMaps.length > 0">
                  <label>Proficiencies (Choose {{profMap.keys().next().value}})</label>
                  <div class="d-flex flex-column">
                    <div class="btn-group">
                      <input #ProfInput type="text" class="form-control dropdown-input"
                             [disabled]="selectedProfs.get(i)?.length === profMap.keys().next().value">
                      <div class="btn-group" ngbDropdown placement="bottom-right" role="group"
                           aria-label="Proficiencies">
                        <button class="btn btn-outline-secondary" ngbDropdownToggle
                                [disabled]="selectedProfs.get(i)?.length === profMap.keys().next().value"></button>
                        <div class="dropdown-menu custom-scrollbar mb-5" ngbDropdownMenu>
                          <button *ngFor="let prof of profMap.get(profMap.keys().next().value)" ngbDropdownItem
                                  (click)="selectProf(prof, profMap.get(profMap.keys().next().value), i); ProfInput.value = prof">
                            {{prof}}
                          </button>
                        </div>
                      </div>
                    </div>
                    <mat-chip-list aria-label="Prof selection">
                  <span class="d-flex justify-content-start flex-wrap w-100 mt-2">
                  <mat-chip *ngFor="let prof of selectedProfs.get(i)" class="d-flex justify-content-between">
                    {{prof}}
                    <fa-icon [icon]="faTimesCircle"
                             (click)="removeProfChip(prof, profMap.get(profMap.keys().next().value), i)"
                             class="text-muted clickable faTimesCircle ml-2">
                    </fa-icon>
                  </mat-chip>
                   </span>
                    </mat-chip-list>
                  </div>
                </div>
              </div>
            </div>

            <div class="bg-light w-100 h-100 pt-2 pr-3 pl-3 border-left pb-2 custom-scrollbar"
                 style="font-size: 0.8em; height: 96%" id="classDescription">
              <p *ngIf="classDescription" [innerHtml]="classDescription | bypassHtml"
                 [@fadeIn]="classDescription"></p>
            </div>
          </div>
        </mat-tab>

        <mat-tab #AbilityScores label="Ability Scores" [disabled]='!AbilityScores.isActive'>
          <app-ability-scores *ngIf="tabIndex === 3" [baseStats]="baseStats"
                              (statEmitter)="saveStats($event)"></app-ability-scores>
        </mat-tab>

        <mat-tab #Equipment label="Equipment" [disabled]='!Equipment.isActive'>
          <app-item-select *ngIf="equipUrl" [equipUrl]="equipUrl" (itemEmitter)="saveItems($event)"></app-item-select>
        </mat-tab>

        <mat-tab #Spells label="Spells" [disabled]='!Spells.isActive'>
          <ngb-alert type="info" [dismissible]="false" class="d-flex align-items-center h-25 mt-3" style="width: 40%"
                     *ngIf="!cantrips && !spellsKnown">
            <fa-icon [icon]="faExclamationTriangle" size="3x" class="mr-4" aria-hidden="true"></fa-icon>
            <h6 class="my-auto">You Get No Spells From Your Class</h6>
          </ngb-alert>
          <app-spell-select *ngIf="cantrips >= 0 && spellsKnown >= 0" [cantrips]="cantrips" [spellsKnown]="spellsKnown"
                            [_class]="characterForm.get('class').value"
                            (spellsEmitter)="saveSpells($event)"></app-spell-select>
        </mat-tab>

        <mat-tab #Results label="Results" [disabled]='!Results.isActive'>
          <button class="btn btn-sm btn-main text-white mt-3" (click)="createCharacter()">
            Create Character
          </button>
        </mat-tab>
      </form>
    </mat-tab-group>

    <div class="d-flex justify-content-between py-2">
      <button (click)="changeTab('Back')" class="btn btn-sm btn-main"
              id="backButton" type="button" [disabled]="tabIndex === 0">Back
      </button>
      <button (click)="changeTab('Next')" class="btn btn-sm btn-main" id="nextButton"
              [disabled]="tabIndex === numTabs - 1">Next
      </button>
    </div>
  </div>
</div>
